import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTokenVerification } from '../hooks/useTokenVerification';
import Loader from './shared/Loader';
import Layout from './layout/Layout';
import ContentList from './content/ContentList';
import Notifications from './notifications/Notifications';
import { StreamApp } from './livestream/StreamApp';
import Statistics from './statistics/Statistics';
import { SocketProvider } from '../contexts/SocketContext';

// Компонент-обертка для защиты livestream от доступа с десктопа
const MobileOnlyRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isMobileWidth, setIsMobileWidth] = useState(window.innerWidth <= 767);

    useEffect(() => {
        const handleResize = () => {
            const newWidth = window.innerWidth <= 767;
            setIsMobileWidth(newWidth);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    // Если экран шире 767px - сразу редирект без сообщения
    if (!isMobileWidth) {
        console.log('🖥️ Desktop detected (width > 767px), redirecting from livestream');
        return <Navigate to="/content/trainings" replace />;
    }

    return <>{children}</>;
};

const Dashboard: React.FC = () => {
    const { authenticated, loading } = useAuth();
    const { verifyToken } = useTokenVerification();
    const location = useLocation();

    // При монтировании компонента проверяем токен
    useEffect(() => {
        verifyToken();
    }, [verifyToken]);

    // Если все еще проверяем авторизацию, показываем индикатор загрузки
    if (loading) {
        return <Loader />;
    }

    // Если нет аутентификации после проверки - перенаправляем на логин
    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    return (
        <Layout>
            <Routes>
                {/* Перенаправляем только если мы находимся на базовом пути /,
                    так как другие пути будут обработаны ниже */}
                <Route index element={
                    location.pathname === "/"
                        ? <Navigate to="content" replace />
                        : null
                } />

                {/* Маршруты основных разделов панели администратора */}
                <Route path="content/*" element={<ContentList />} />
                <Route path="notifications" element={<Notifications />} />
                {/* Livestream доступен только на мобильных устройствах (ширина <= 767px) */}
                <Route
                    path="livestream"
                    element={
                        <MobileOnlyRoute>
                            <SocketProvider>
                                <StreamApp />
                            </SocketProvider>
                        </MobileOnlyRoute>
                    }
                />
                {/* Recordings moved under Content tabs */}
                <Route path="statistics" element={<Statistics />} />
            </Routes>
        </Layout>
    );
};

export default Dashboard;